import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsWaterNormalMedium = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.83 14.74A5.49 5.49 0 0013.5 18a5.49 5.49 0 004.67-3.26A5.49 5.49 0 0022.83 18a5.25 5.25 0 003-.92.5.5 0 10-.57-.82 4.23 4.23 0 01-2.38.74c-2 0-3.54-1.84-4.2-3.67a.5.5 0 00-.94 0C17 15.16 15.49 17 13.5 17s-3.5-1.84-4.2-3.67a.52.52 0 00-.94 0C7.71 15.16 6.16 17 4.17 17a4.23 4.23 0 01-2.38-.74.5.5 0 10-.57.82 5.25 5.25 0 003 .92 5.49 5.49 0 004.61-3.26zM8.17 9a5.49 5.49 0 004.67-3.26A5.49 5.49 0 0017.5 9a5.49 5.49 0 004.67-3.26A5.49 5.49 0 0026.83 9a5.25 5.25 0 003-.92.5.5 0 00-.57-.82 4.23 4.23 0 01-2.43.74c-2 0-3.54-1.84-4.2-3.67a.5.5 0 00-.94 0C21 6.16 19.49 8 17.5 8S14 6.16 13.3 4.33a.52.52 0 00-.94 0C11.71 6.16 10.16 8 8.17 8a4.23 4.23 0 01-2.38-.74.5.5 0 10-.57.82A5.25 5.25 0 008.17 9zM29.21 25.26a4.23 4.23 0 01-2.38.74c-2 0-3.54-1.84-4.2-3.67a.5.5 0 00-.94 0C21 24.16 19.49 26 17.5 26s-3.5-1.84-4.2-3.67a.52.52 0 00-.94 0c-.65 1.83-2.2 3.67-4.19 3.67a4.23 4.23 0 01-2.38-.74.5.5 0 10-.57.82 5.25 5.25 0 003 .92 5.49 5.49 0 004.67-3.26A5.49 5.49 0 0017.5 27a5.49 5.49 0 004.67-3.26A5.49 5.49 0 0026.83 27a5.25 5.25 0 003-.92.5.5 0 10-.57-.82z"
  }));
});
SvgSportsWaterNormalMedium.defaultProps = {
  height: 32,
  width: 32
};
SvgSportsWaterNormalMedium.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsWaterNormalMedium;